/** @flow */
import { startRequest, finishRequest } from "@store/utils";
import {
  GetReportingFocusListsEmployeeReport,
  GetReportingFocusListsEmployeeReportSuccess,
  GetReportingFocusListsEmployeeReportError,
  ExportFocusListsEmployeeReport,
  ExportFocusListsEmployeeReportSuccess,
} from "@modules/reporting/constants/actions";
import type { ReportState } from "./types";
import { cloneObject } from "@utils/object";

export const initialState = {
  requestsInProgress: 0,
  reportGenerateInProgress: 0,
  error: null,
  details: null,
  reportData: null,
  charts: {
    percentageOfAbsence: null,
    top10: [],
    percentageOfEmployees: null,
  },
};

export const setLoading = (state: ReportState) => () => startRequest(state);

export const onGetReportingFocusListsEmployeeReportSuccess = (state: ReportState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: null,
  canSave: payload.canSave,
  details: payload.details,
  reportData: payload.reportData,
  charts: {
    percentageOfEmployees: payload.percentageOfEmployees,
    percentageOfAbsence: payload.percentageOfAbsence,
    top10: payload.top10,
  },
});

const onGetReportingFocusListsEmployeeReportError = (state: ReportState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload.error,
});

const onExportFocusListsEmployeeReportSuccess = (state: ReportState) => () => ({
  ...finishRequest(state),
});

export default (state: ReportState = initialState, action: Object): ReportState => {
  const act = {
    [GetReportingFocusListsEmployeeReport]: setLoading,
    [GetReportingFocusListsEmployeeReportSuccess]: onGetReportingFocusListsEmployeeReportSuccess,
    [GetReportingFocusListsEmployeeReportError]: onGetReportingFocusListsEmployeeReportError,
    [ExportFocusListsEmployeeReport]: setLoading,
    [ExportFocusListsEmployeeReportSuccess]: onExportFocusListsEmployeeReportSuccess,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
